import template from './branches_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class BranchesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class BranchesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new BranchesHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'BranchesHelp',
	dialog_class: BranchesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/branches_help',
	provider: 'ps'
};
